import { render, staticRenderFns } from "./topicFrom.vue?vue&type=template&id=e0625298&scoped=true"
import script from "./topicFrom.vue?vue&type=script&lang=js"
export * from "./topicFrom.vue?vue&type=script&lang=js"
import style0 from "./topicFrom.vue?vue&type=style&index=0&id=e0625298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0625298",
  null
  
)

export default component.exports